/**
 * created by lei lei on 2020/6/5
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'

import {ContentUtils} from 'braft-utils'
import {Input, Button, Modal, message} from 'antd';
import {ImageUtils} from 'braft-finder'
import {uuid} from "../../../utils";
import UploadWall from "../../../components/upload/UploadWall";
import {PIC_TYPE} from "../../../constants";
import {delResource, pictureConvertParams} from "../../../actions/interview";
import {Scrollbars} from "react-custom-scrollbars";
import pictureIcon from"./img/pictureIcon.png"
import xiuMiCIon from"./img/xiuMiIcon.png"

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default class Editor extends Component {
    static defaultProps = {
        customHeight: 500,
        isShowMedia: false,
        imgBtnShow: false,
        xiuMiBtnShow: false,
    };
    static propTypes = {
        callBackeditorContent: PropTypes.func.isRequired,//回调编辑器返回的内容，属于必传项，必须传入
        customHeight: PropTypes.number,//编辑器的高度，自定义默认不传是500,
        isShowMedia: PropTypes.bool,//是否展示媒体插入
        imgBtnShow: PropTypes.bool,//是否展示图片按钮
        xiuMiBtnShow: PropTypes.bool,//是否展示秀米编辑器
    };
    state = {
        editorState: BraftEditor.createEditorState(this.props.content),
        linkContent: '',
        imgVisible: false,
        fileList: [],//图片数据
        previewVisible: false,
        previewImage: '',
    };


    handleChange = (editorState) => {
        this.props.callBackeditorContent && this.props.callBackeditorContent(editorState.toHTML())
        this.setState({editorState})

    };

    componentWillReceiveProps(nextProps, nextContext) {
        let content = nextProps.content;
        if (nextProps.isUpDate) {
            this.setState({
                editorState: BraftEditor.createEditorState(content)
            })
        }

    }


    render() {

        const controls = ['undo', 'redo', 'separator',
            'font-size', 'font-family', 'line-height', 'letter-spacing', 'separator',
            'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
            'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator',
            'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator',
            'separator', 'hr', 'separator',
            this.props.isShowMedia ? 'media' : '',
            'separator',
            'clear'];
        const fontFamily = [{
            name: '微软雅黑',
            family: 'MicrosoftYaHei'
        }, {
            name: 'Araial',
            family: 'Arial, Helvetica, sans-serif'
        }, {
            name: 'Georgia',
            family: 'Georgia, serif'
        }, {
            name: 'Impact',
            family: 'Impact, serif'
        }, {
            name: 'Monospace',
            family: '"Courier New", Courier, monospace'
        }, {
            name: 'Tahoma',
            family: 'tahoma, arial, "Hiragino Sans GB", 宋体, sans-serif'
        }];
        const extendControls = [
            'separator',
            {
                key: 'my-dropdown',
                type: 'dropdown',
                title: '超链接', // 指定鼠标悬停提示文案
                className: 'my-dropdown', // 指定下拉组件容器的样式名
                html: null, // 指定在按钮中渲染的html字符串
                text: '超链接', // 指定按钮文字，此处可传入jsx，若已指定html，则text不会显示
                showArrow: true, // 指定是否显示下拉组件顶部的小三角形
                arrowActive: false, // 指定是否高亮下拉组件顶部的小三角形
                autoHide: true, // 指定是否在失去焦点时自动隐藏下拉组件
                component: <div style={{padding: 5, display: 'flex', width: 350}}>
                    <Input placeholder="请输入插入链接" value={this.state.linkContent} style={{width: 300}}
                           onChange={(e) => {
                               console.log(e);
                               this.setState({
                                   linkContent: e.target.value
                               })
                           }
                           }
                    /> <Button type="primary" style={{width: 50}} onClick={() => {
                    this.setState({
                        linkContent: '',
                        editorState: ContentUtils.insertHTML(this.state.editorState, '<a href="' + this.state.linkContent + '"><span color="#ff0000;">' + this.state.linkContent + '</span></a>')
                    })
                }}>确定</Button>
                </div>, // 指定在下拉组件中显示的内容组件
            },
        ];
        //是否显示上传图片按钮
        if (this.props.imgBtnShow) {
            extendControls.push('separator',
                {
                    key: 'img',
                    type: 'button',
                    text: <div ><img src={pictureIcon} style={{width:20,height:20}} alt=""/></div>,
                    onClick: () => {
                        this.setState({imgVisible: true, fileList: []})
                    }
                }
            )
        }
        //是否显示秀米按钮
        if (this.props.xiuMiBtnShow) {
            extendControls.push('separator',
                {
                    key: 'xiuMi',
                    type: 'button',
                    text: <div ><img style={{width:25,height:25}} src={xiuMiCIon} alt=""/></div>,
                    onClick: () => {
                        this.props.goXiuMi && this.props.goXiuMi()
                    }
                })
        }
        const {previewVisible, previewImage} = this.state;
        return (
            <div>
                <div className="editor-wrapper">
                    <BraftEditor
                        value={this.state.editorState}
                        fontFamilies={fontFamily}
                        ref={(instance) => this.editorInstance = instance}
                        media={{
                            allowPasteImage: true,
                            image: true, // 开启图片插入功能
                            video: false, // 开启视频插入功能
                            audio: false, // 开启音频插入功能
                        }}
                        contentStyle={{border: '1px solid #ececec', height: this.props.customHeight}}
                        onChange={this.handleChange}
                        controls={controls}
                        extendControls={extendControls}
                    />
                </div>
                {/*继承图片编辑器*/}
                {this.renderAddIngModal()}
                {/*图片预览*/}
                {this.renderReviewImg()}
            </div>
        )

    }

    //渲染图片上传功能
    renderAddIngModal() {
        return (<Modal
            title="添加图片"
            visible={this.state.imgVisible}
            onOk={() => this.addImgToEdit()}
            width={840}
            onCancel={() => {
                this.setState({imgVisible: false, fileList: []})
            }}
        >
            <div style={{width: 800, padding: '0 10px', height: 500}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={600}
                >
                    <UploadWall
                        accept={"." + PIC_TYPE.join(",.")}
                        multiple={true}
                        action="/cm-sites-pms/index/uploadFile"
                        listType="picture-card"
                        fileList={this.state.fileList}
                        icons={["eye", "download"]}
                        uploadBtnName={"上传图片"}
                        onPreview={this.handlePreview}
                        onChange={this.imgHandleChange}
                        onRemove={this.handleRemove}
                        showUploadBtn={this.props.currentUser ? this.isHaveUploadAuth(this.props.data, this.props.currentUser) : true}
                    />
                </Scrollbars>
            </div>
        </Modal>)
    }

    //渲染图片预览功能
    renderReviewImg() {
        return (
            <Modal visible={this.state.previewVisible} footer={null} onCancel={() => {
                this.setState({previewVisible: false})
            }}
                   width={600} bodyStyle={{height: 600}}
            >
                <table cellSpacing={0} cellPadding={0} border={0} width={"100%"} height={"100%"}>
                    <tbody>
                    <tr>
                        <td align={"center"} valign={"middle"}><img style={{maxWidth: 552, maxHeight: 552}}
                                                                    alt="example" src={this.state.previewImage}/></td>
                    </tr>
                    </tbody>
                </table>
            </Modal>
        )
    }

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    imgHandleChange = ({file, fileList}) => {
        if (fileList.length > 8) {
            message.warning('最多上传8张');
            return;
        }
        if (file.status === "done") {
            file.response.interviewId = this.props.data ? this.props.data.id : 0;
            let newFileList = fileList.map(item => {
                item.url = item.response.url;
                item.path = item.response.url;
                item.resourceId = item.uid;
                item.type = 'IMAGE';//不可删除
                return item;
            });
            this.setState({fileList: newFileList});
        }
        this.setState({fileList});
    };

    handleRemove = async file => {
        delResource(this.props.data.id, file.resourceId);
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item => {
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    //添加图片到编辑器
    addImgToEdit() {
        this.setState({
            imgVisible: false,
            fileList: [],
            editorState: ContentUtils.insertMedias(this.state.editorState, this.state.fileList)
        })
    }

}